import { useMemo } from 'react'

import { numberFormatter } from '@fortem-monorepo/js-utilities'
import { createColDefs } from '@fortem-monorepo/react-ag'
import { CustomAgGrid } from '@fortem-monorepo/react-ag'
import { ICReport } from '@fortem-monorepo/web-sdk'

import { ICReportTablePrimitive } from '@/pages/funds/ic-report/components/primitives/types'
import { fundLevel } from '@/react-query/queries/ic-report/hooks'

const percentageFormatter = numberFormatter({
  suffix: '%',
})

const getColumnDefs = (data?: ICReport.GetStressTestData) => {
  return createColDefs<ICReport.GetStressTestData['data'][number]>([
    { field: 'investment_bucket', headerName: 'Bucket' },
    ...(data?.columns ?? []).map((column) => ({
      field: column,
      valueFormatter: percentageFormatter,
    })),
  ])
}

export interface StressTestTableProps extends ICReportTablePrimitive {}

export const StressTestTable: React.FC<StressTestTableProps> = ({ params, options }) => {
  const query = fundLevel.useStressTest(params)
  const data = query.data

  const columns = useMemo(() => {
    return getColumnDefs(data)
  }, [data])

  return <CustomAgGrid rowData={data?.data ?? []} columnDefs={columns} {...options} />
}
